import { fetcher } from '@/src/general/utilities/fetcher'

import type { ABUSE_TYPE } from '../models/Abuse.enums'
import type { TReportAbusePayload } from './types/reportAbuse'

export const abuseApi = {
  reportAbuse: async (type: ABUSE_TYPE, id: number, payload: TReportAbusePayload) =>
    fetcher.mutate<void, TReportAbusePayload>(`/${type}/${id}/report-abuse`, payload, {
      method: 'POST',
    }),
}
